/* eslint no-console: off */
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useCallback, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import Input from '../Input';
import styles from './LoginForm.module.scss';
import ToastMessage from '../Toast';
import Vip29ApiService from '../../../services/Vip29ApiService';
import * as tse from '../../../utils/transactionSymmetricEncryption';

const BookingSchema = yup.object().shape({
    email: yup.string().email().required('Required Email'),
    password: yup.string().required('Required Password'),
});

const LoginForm = (props) => {
    const { liffProfile, isLineBrowser } = props;
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            booking_by_type: 'pick_up',
        },
        resolver: yupResolver(BookingSchema),
    });

    const notify = useCallback((type, message) => {
        ToastMessage({ type, message });
        return null;
    }, []);

    const submitLogin = async (formData) => {
        setLoading(true);
        try {
            // Verify code
            const { code } = await Vip29ApiService.verifyCode({
                email: formData.email,
            });

            // ENCRYPTION
            let formEnc = {
                ...formData,
                code,
            };
            if (isLineBrowser) {
                formEnc = {
                    ...formEnc,
                    line_id: liffProfile?.userId || null,
                };
            }
            const enc_data = tse.encrypt(formEnc, process.env.SDP_SALT);

            // Authentication
            const data = await Vip29ApiService.loginWithSetAccessTokenOnly({
                enc_data,
            });

            props.callbackToken(data);
            notify('success', 'Login Success');
        } catch (error) {
            notify('error', error?.message || 'Error');
            setLoading(false);
        }
    };

    const onSubmit = (data) => {
        submitLogin(data);
    };

    return (
        <div className={styles.wrapper}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.formGroup}>
                    <Input
                        required={true}
                        label="Email"
                        errors={errors}
                        register={register('email')}
                    />
                </div>
                <div className={styles.formGroup}>
                    <Input
                        type="password"
                        required={true}
                        label="Password"
                        errors={errors}
                        register={register('password')}
                    />
                </div>
                <div className={styles.btnWrapper}>
                    <button
                        className={`${styles.bookingBtn} ${
                            loading ? styles.btnDisable : ''
                        }`}
                        type="submit"
                    >
                        <span>
                            {loading ? 'Just a moment' : 'LOG IN'}
                            {loading && (
                                <FaSpinner className="loading-icon-payment" />
                            )}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default LoginForm;
